<script setup lang="ts">
import { useCategorySearch } from '@shopware-pwa/composables-next'
import { Ref } from 'vue'
import { Category } from '@shopware-pwa/types'
import { useShopBreadcrumbs } from './composables/useShopBreadcrumbs'
import { createMetaInfoObject } from '~/lib'

const props = defineProps<{
  foreignKey: string
}>()

const { search } = useCategorySearch()
const route = useRoute()

const { data: categoryResponse } = await useAsyncData('cmsNavigation' + props.foreignKey, async () => {
  const category = await search(props.foreignKey, {
    withCmsAssociations: false,
  })
  return category
})
const { category } = useCategory(categoryResponse as Ref<Category>)

const { breadcrumbs } = useShopBreadcrumbs(category.value)

useShopwareMetaTags(category.value)
</script>
<template>
  <Hero class="section-hero" :content="{ title: category.translated.name }" :breadcrumbs="breadcrumbs" />
  <SectionIntrotext
    v-if="category.translated.description"
    v-animate="{ animation: 'vertical-reveal' }"
    :text="category.translated.description"
  />
  <section class="section">
    <div class="grid container">
      <div class="t-10 t-o-1 tl-o-0 ds-o-1 ds-8">
        <ShopSubcategories :category="category" />
      </div>
      <ShopProductListing :category="category" />
    </div>
  </section>
</template>
<style scoped lang="scss">
:deep(.subcategories) {
  @include fluid(margin-bottom, 32px, 128px);
}
</style>
